import {useIntl} from 'react-intl';
import * as React from 'react';
import {useEffect, useState, useRef} from 'react';
import {saveAs} from "file-saver";
import {FloatLabel} from "primereact/floatlabel";
import {Calendar} from "primereact/calendar";
import {Button} from "primereact/button";
import {Api} from "../../../lib/services/mainApi";
import moment from "moment";
import {useDialog} from "../../../lib/hooks/useDialog";

interface Props {

}

const CSVDialog : React.FC<Props> = props => {
    const {formatMessage: f} = useIntl();
    const didMountRef = useRef(false);

    const api = new Api();
    const {hideDialog} = useDialog();

    const [startDate, setStartDate] = useState<any>()
    const [endDate, setEndDate] = useState<any>()


    useEffect(() => {
        if(!didMountRef.current) {
            didMountRef.current = true;
        }
    }, []);

    const handleExport = () => {
        api.api.adminV1GetcsvCreate({endTime: moment(endDate).utc().unix(), startTime: moment(startDate).utc().unix()})
            .then(res => {
                const fileName = res.headers['content-disposition'].split('filename=')[1].split(';')[0];
                const blob = new Blob([res.data as BlobPart], {type: res.headers["content-type"]});
                saveAs(blob, fileName);
            })
    }

    return <div className={"flex grid"}>
        <FloatLabel className={"col-12 md:col-6 mt-4"}>
            <Calendar id="startDate" className={"p-inputtext-lg w-full"} value={startDate} onChange={(e) => setStartDate(e.value)} selectionMode={"single"}/>
            <label className={"ml-2"} htmlFor="startDate">{f({id: "startDate"})}</label>
        </FloatLabel>

        <FloatLabel className={"col-12 md:col-6 mt-4"}>
            <Calendar id="endDate" className={"p-inputtext-lg w-full"} value={endDate} onChange={(e) => setEndDate(e.value)} selectionMode={"single"}/>
            <label className={"ml-2"} htmlFor="endDate">{f({id: "endDate"})}</label>
        </FloatLabel>


        <div className={"col-12 flex justify-content-between"}>
            <Button className={"col-4"} label={f({id: "export"})} disabled={!startDate || !endDate} onClick={handleExport}/>
            <Button className={"col-4"} label={f({id: "cancel"})} onClick={hideDialog}/>
        </div>

    </div>
};

export default CSVDialog
